import { getBusinessConfig } from "@/apis/crypto";
import { Toast } from "antd-mobile";
import { useEffect, useState } from "react";
import './index.scss';
import txt from "@/assets/images/merchant/subsidy/txt.png";
import merchant from "@/assets/images/merchant/subsidy/merchant.png";
import logo from "@/assets/images/merchant/subsidy/logo.png";
const data = {
  sellingConfig: {
    wechatAlipayAmountMin: {
      min: 10,
      max: 10000
    },
    wechatAlipayAmountMiddle: {
      min: 10001,
      max: 30000
    },
    wechatAlipayAmountMax: {
      min: 30001,
      max: 60000
    },
    bankCardAmountMin: {
      min: 33,
      max: 10000
    },
    bankCardAmountMiddle: {
      min: 10003,
      max: 30000
    },
    bankCardAmountMax: {
      min: 30001,
      max: 60000
    }
  },
  config: {
    silverBusinessDepositScope: {
      min: 1,
      max: 5000
    },
    silverBusinessWechatAlipayReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    silverBusinessBankCardReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    ordinaryBusinessDepositScope: {
      min: 1,
      max: 10000
    },
    ordinaryBusinessWechatAlipayReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    ordinaryBusinessBankCardReward: {
      min: 1,
      middle: 1,
      max: 1
    },
    platinumGoldBusinessDepositScope: {
      min: 10001,
      max: 20000
    },
    platinumGoldBusinessWechatAlipayReward: {
      min: 2,
      middle: 2,
      max: 2
    },
    platinumGoldBusinessBankCardReward: {
      min: 2,
      middle: 2,
      max: 2
    },
    diamondBusinessDepositScope: {
      min: 20001,
      max: 30000
    },
    diamondBusinessWechatAlipayReward: {
      min: 3,
      middle: 3,
      max: 3
    },
    diamondBusinessBankCardReward: {
      min: 3,
      middle: 3,
      max: 3
    },
    crownBusinessDepositScope: {
      min: 30001,
      max: 40000
    },
    crownBusinessWechatAlipayReward: {
      min: 4,
      middle: 4,
      max: 4
    },
    crownBusinessBankCardReward: {
      min: 4,
      middle: 4,
      max: 4
    }
  }
};
export const Detail = ({
  title,
  hideAlipayWechatAtMerchantPage
}: any) => {
  const [config, setConfig] = useState<any>(data.config);
  const [sellingConfig, setSellingConfig] = useState<any>(data.sellingConfig);
  const fetchBusinessConfig = async () => {
    const {
      ok,
      data,
      msg
    } = await getBusinessConfig();
    if (ok) {
      setConfig(data.business_range_config);
      setSellingConfig(data.amount_range_config);
    } else {
      Toast.show(msg);
    }
  };
  useEffect(() => {
    fetchBusinessConfig();
  }, []);
  return <div className="earn_page_detail_block" data-sentry-component="Detail" data-sentry-source-file="Detail.tsx">
      <div className="earn_page_detail_title">商家协议：</div>
      <div className="earn_page_detail_content">
        <p>
          <span className="earn_page_detail_label"> 1.商家定义： </span>
          您用数字货币与平台用户资金进行等额兑换，赚取平台补贴，转入数字货币按实时汇率兑换V币（V币汇率锚定CNY），商家需自行判断和承担法律风险；若触发相应风控，需自行承担相应解封、解冻的配合义务。
        </p>
        <p>
          <span className="earn_page_detail_label"> 2.免责声明： </span>
          {title}钱包作为知名平台，已对所有用户进行把关审核，按国际《反洗钱法》、《反恐怖法》制定相应风控措施，平台将尽最大努力监督资金安全与干净。如交易过程遇到极端不可控情形，商家有义务自行判断，遵守您所在地的法律法规，并自愿承担相应后果。
        </p>
        <div className="earn_bg_box">
           <img className="earn_logo" src={logo} alt="" />
           <div className="earn_txt"> 
              <img src={txt} alt="" />
           </div>
           <div className="earn_txt2"> 
              <img src={merchant} alt="" />
           </div>
        </div>
        {/* <div className="earn_page_detail_table_header">商家补贴比例<span>（随市场和政策浮动）</span></div> */}
        <table className="earn_page_detail_table">
          <thead>
            {/* <tr>
              <th className="earn_page_detail_headLine" rowSpan={2}>
                <span className="earn_page_detail_leftBottom">变现</span>
              </th>
              <th colSpan={6}>
                <span className="earn_page_detail_rightTop">商家等级</span>
              </th>
             </tr> */}
            <tr>
              <th className="headLine">
                <span className="leftBottom">变现</span>
                <span className="rightTop">商家</span>
              </th>
              <th>
                白银
              </th>
              <th>
                黄金
              </th>
              <th>
                铂金
              </th>
              <th>
                钻石
              </th>
              <th>
                皇冠
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><span>保证金</span></td>
              <td>{config.silverBusinessDepositScope.min}U起</td>
              <td>{config.ordinaryBusinessDepositScope.min}U起</td>
              <td>{config.platinumGoldBusinessDepositScope.min}U起</td>
              <td>{config.diamondBusinessDepositScope.min}U起</td>
              <td>{config.crownBusinessDepositScope.min}U起</td>
            </tr>
            <tr style={{
            display: !hideAlipayWechatAtMerchantPage ? 'table-row' : 'none'
          }}>
              <td>
                微信/支付宝 <br />
                <span>小额{sellingConfig.wechatAlipayAmountMin.min}~{sellingConfig.wechatAlipayAmountMin.max}</span>
              </td>
              <td>{config.silverBusinessWechatAlipayReward.min}%</td>
              <td>{config.ordinaryBusinessWechatAlipayReward.min}%</td>
              <td>{config.platinumGoldBusinessWechatAlipayReward.min}%</td>
              <td>{config.diamondBusinessWechatAlipayReward.min}%</td>
              <td>{config.crownBusinessWechatAlipayReward.min}%</td>
            </tr>
            <tr style={{
            display: !hideAlipayWechatAtMerchantPage ? 'table-row' : 'none'
          }}>
              <td>
                微信/支付宝 <br />
                <span>中额{sellingConfig.wechatAlipayAmountMiddle.min}~{sellingConfig.wechatAlipayAmountMiddle.max}</span>
              </td>
              <td>{config.silverBusinessWechatAlipayReward.middle}%</td>
              <td>{config.ordinaryBusinessWechatAlipayReward.middle}%</td>
              <td>{config.platinumGoldBusinessWechatAlipayReward.middle}%</td>
              <td>{config.diamondBusinessWechatAlipayReward.middle}%</td>
              <td>{config.crownBusinessWechatAlipayReward.middle}%</td>
            </tr>
            <tr style={{
            display: !hideAlipayWechatAtMerchantPage ? 'table-row' : 'none'
          }}>
              <td>
                微信/支付宝 <br />
                <span>大额{sellingConfig.wechatAlipayAmountMax.min}以上</span>
              </td>
              <td>{config.silverBusinessWechatAlipayReward.max}%</td>
              <td>{config.ordinaryBusinessWechatAlipayReward.max}%</td>
              <td>{config.platinumGoldBusinessWechatAlipayReward.max}%</td>
              <td>{config.diamondBusinessWechatAlipayReward.max}%</td>
              <td>{config.crownBusinessWechatAlipayReward.max}%</td>
            </tr>
            <tr>
              <td>
                银行卡 <br />
                <span>小额{sellingConfig.bankCardAmountMin.min}~{sellingConfig.bankCardAmountMin.max}</span>
              </td>
              <td>{config.silverBusinessBankCardReward.min}%</td>
              <td>{config.ordinaryBusinessBankCardReward.min}%</td>
              <td>{config.platinumGoldBusinessBankCardReward.min}%</td>
              <td>{config.diamondBusinessBankCardReward.min}%</td>
              <td>{config.crownBusinessBankCardReward.min}%</td>
            </tr>
            <tr>
              <td>
                银行卡 <br />
                <span>中额{sellingConfig.bankCardAmountMiddle.min}~{sellingConfig.bankCardAmountMiddle.max}</span>
              </td>
              <td>{config.silverBusinessBankCardReward.middle}%</td>
              <td>{config.ordinaryBusinessBankCardReward.middle}%</td>
              <td>{config.platinumGoldBusinessBankCardReward.middle}%</td>
              <td>{config.diamondBusinessBankCardReward.middle}%</td>
              <td>{config.crownBusinessBankCardReward.middle}%</td>
            </tr>
            <tr>
              <td>
                银行卡 <br />
                <span>大额{sellingConfig.bankCardAmountMax.min}以上</span>
              </td>
              <td>{config.silverBusinessBankCardReward.max}%</td>
              <td>{config.ordinaryBusinessBankCardReward.max}%</td>
              <td>{config.platinumGoldBusinessBankCardReward.max}%</td>
              <td>{config.diamondBusinessBankCardReward.max}%</td>
              <td>{config.crownBusinessBankCardReward.max}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>;
};